import { createSlice } from '@reduxjs/toolkit'

const menuData = createSlice({
    name: 'menuData',//Данные для виджетов 
    initialState: {
        task: 0,//Счетчик новых задач
        taskOverdue: 0,//Счетчик просроченных задач
        taskR: 0,//Счетчик новых регулярных задач
        taskROverdue: 0,//Счетчик просроченных регулярных задач
        board: 0,//Счетчик новых задач в досках
        boardOverdue: 0,//Счетчик просроченных задач в досках
        message: 0,//Счетчик новых сообщений
        menuMainShow: true, //Показывать главное меню
        menuMainMobileShow: false, //Показывать главное меню. Мобильная версия
        menuMobileShow: false, //Показывать меню пользователя 1
        menuUserShow: false, //Показывать меню пользователя 2     
    },
    reducers: {
        loadAll(state, action) {
            state.task = action.payload.data.Count_Task;
            state.taskOverdue = action.payload.data.Count_Task_Overdue;
            state.taskR = action.payload.data.Count_TaskR;
            state.taskROverdue = action.payload.data.Count_TaskR_Overdue;
            state.board = action.payload.data.Count_Board;
            state.boardOverdue = action.payload.data.Count_Board_Overdue;
            state.message = action.payload.data.Count_Message;
        },
        updateTask(state, action) {
            state.task = action.payload.data;
        },
        updateTaskOverdue(state, action) {
            state.taskOverdue = action.payload.data;
        },
        updateTaskR(state, action) {
            state.taskR = action.payload.data;
        },
        updateTaskROverdue(state, action) {
            state.taskROverdue = action.payload.data;
        },
        updateBoard(state, action) {
            state.board = action.payload.data;
        },
        updateBoardOverdue(state, action) {
            state.boardOverdue = action.payload.data;
        },
        updateMessage(state, action) {
            state.message = action.payload.data;
        },
        setMenuMainShow(state, action) {
            state.menuMainShow = action.payload.data;
        },
        setMenuMainMobileShow(state, action) {
            state.menuMainMobileShow = action.payload.data;
        },
        setMenuUserShow(state, action) {
            state.menuUserShow = action.payload.data;
        },
        setMenuMobileShow(state, action) {
            state.menuMobileShow = action.payload.data;
        }
    }
})

export const { loadAll, updateTaskR, updateTask, updateBoard, updateBoardOverdue, updateMessage, updateTaskOverdue, updateTaskROverdue, setMenuMainShow, setMenuUserShow, setMenuMobileShow, setMenuMainMobileShow } = menuData.actions
export default menuData.reducer